import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { tenantConfigApi } from 'src/app/core/services/api-proxy/data';
import { TenantService } from 'src/app/shared/services/tenant.service';
import { environment } from 'src/environments/environment';
import * as SystemActions from './system.actions';

@Injectable()
export class SystemEffects {
  getTenantConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SystemActions.getTenantConfig),
      mergeMap(() =>
        this.tenantService.getTenantConfig().pipe(
          map((config: any) => {
            let tenantConfig;
            try {
              tenantConfig = JSON.parse(config?.config);
            } catch (error) {
              console.error(
                '[system.effects] Erro ao fazer JSON.parse em config.config',
                config?.config,
                error
              );
              return SystemActions.getTenantConfigFail({
                error: 'JSON Parse fail',
              });
            }
            // 4-1-8-2-6
            // if (!environment.production) {
            //   tenantConfig = {
            //     ...tenantConfig,
            //     ...tenantConfigApi
            //   };
            // }

            return SystemActions.getTenantConfigSuccess({ tenantConfig });
          }),
          catchError((error) =>
            of(SystemActions.getTenantConfigFail({ error }))
          )
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private tenantService: TenantService
  ) { }
}
